/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {extendRestriction} from '../api'

export const useMutationExtendRestriction = createReactQueryMutationHook('extendRestriction', extendRestriction)
